// Pure data — zero imports (SEO-safe).
//
// AC appears on both bus and private sets with the same short label so
// travellers know every vehicle is air-conditioned. Pickup language stays
// product-specific (hotel pickup vs door-to-door).

const AC_TRUST = { id: 'ac', label: 'Air-conditioned', icon: 'Wind' };

export const BUS_TRUST_INLINE = [
  { id: 'pickup', label: 'Hotel pickup', icon: 'MapPin' },
  { id: 'confirm', label: 'Instant confirmation', icon: 'BadgeCheck' },
  { id: 'changes', label: 'Free date changes', icon: 'CalendarClock' },
  AC_TRUST,
  { id: 'cancel', label: 'Generous cancellation', icon: 'RotateCcw' },
];

export const BUS_TRUST_LIST = [
  {
    id: 'pickup',
    label: 'Complimentary hotel pick-up',
    detail: 'Selected city-centre hotels and agreed meeting points.',
    icon: 'MapPin',
  },
  {
    id: 'confirm',
    label: 'Instant e-ticket confirmation',
    detail: 'Your ticket arrives by email the moment you book.',
    icon: 'BadgeCheck',
  },
  {
    id: 'changes',
    label: 'Free date changes',
    detail: 'Up to 12 hours before departure, subject to availability.',
    icon: 'CalendarClock',
  },
  {
    id: 'ac',
    label: 'Air-conditioned shuttles',
    detail: 'All scheduled services run in comfortable, air-conditioned vehicles.',
    icon: 'Wind',
  },
  {
    id: 'cancel',
    label: 'Generous cancellation policy',
    detail: 'Full refund minus a small admin fee when cancelled in advance.',
    icon: 'RotateCcw',
    policyLink: true,
  },
  {
    id: 'luggage',
    label: '2 bags + backpack included',
    detail: 'Max 30 kg per bag, per passenger.',
    icon: 'Luggage',
  },
  {
    id: 'border',
    label: 'Namanga border crossing',
    detail: 'Time allowed for customs processing.',
    icon: 'Globe',
  },
];

export const PRIVATE_TRUST_INLINE = [
  { id: 'door', label: 'Door-to-door', icon: 'DoorOpen' },
  { id: 'quote', label: 'Instant quote', icon: 'Zap' },
  AC_TRUST,
  { id: 'cancel', label: 'Generous cancellation', icon: 'RotateCcw' },
];

/** Homepage hero — both products; shared AC + distinct pickup. */
export const HOME_HERO_TRUST = [
  { id: 'pickup', label: 'Hotel pickup', icon: 'MapPin' },
  { id: 'door', label: 'Door-to-door private transfers', icon: 'DoorOpen' },
  AC_TRUST,
  { id: 'changes', label: 'Free date changes', icon: 'CalendarClock' },
  { id: 'cancel', label: 'Generous cancellation', icon: 'RotateCcw' },
];

/** Bus product card — shuttle-specific + AC. */
export const BUS_CARD_TRUST = [
  { id: 'pickup', label: 'Hotel pickup', icon: 'MapPin' },
  { id: 'confirm', label: 'Instant confirmation', icon: 'BadgeCheck' },
  { id: 'changes', label: 'Free date changes', icon: 'CalendarClock' },
  AC_TRUST,
];

/** Private product card — charter-specific + AC. */
export const PRIVATE_CARD_TRUST = [
  { id: 'door', label: 'Door-to-door private transfers', icon: 'DoorOpen' },
  { id: 'quote', label: 'Instant quote', icon: 'Zap' },
  AC_TRUST,
];
